:host {
  display: block;
  padding-top: 15px;
}

.items {
  display: flex;
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 0;
  .item {
    font-family: var(--primary-font);
    font-weight: var(--font-weight-normal);
    font-size: 16px;
    color: var(--color-nero);

    &:not(:last-child):hover {
      .text {
        opacity: 0.7;
      }
    }

    &.nero {
      color: var(--color-nero);
    }
    &.white {
      color: var(--color-white);
    }
    &.silver {
      color: var(--color-silver);
    }
    &.bleached-silk {
      color: var(--color-bleached-silk);
    }
    &.anthrazit {
      color: var(--color-livique-anthrazit);
    }
    &.cherryade {
      color: var(--color-livique-cherryade);
    }
    &.blue {
      color: var(--color-blue);
    }
    &.green-seduction {
      color: var(--color-livique-green-seduction);
    }
    &.success {
      color: var(--color-success);
    }
    &.warning {
      color: var(--color-warning);
    }
    &.danger {
      color: var(--color-danger);
    }

    & * > span {
      margin-right: 8px;
    }

    a {
      text-decoration: none;
      color: inherit;

      .arrow-left {
        display: inline;
        font-family: var(--primary-icon-font);

        @include breakpointMin('md') {
          display: none;
        }

        &:before {
          content: '\e80d';
          font-size: 10px;
          position: relative;
          top: -2px;
          left: 0;
        }
      }

      .arrow-right {
        display: none;
        position: relative;
        font-family: var(--primary-icon-font);

        @include breakpointMin('md') {
          display: inline;
        }

        &:before {
          content: '\e80c';
          font-size: 10px;
          position: relative;
          top: 0;
          left: 0;
        }
      }
    }

    &:not(:nth-last-child(2)) {
      display: none;

      @include breakpointMin('md') {
        display: inline;
      }
    }

    &:last-child {
      font-weight: var(--font-weight-bold);

      .arrow-right {
        &:before {
          display: none;
        }
      }
      &.nero {
        color: var(--color-nero);
      }
      &.white {
        color: var(--color-white);
      }
      &.silver {
        color: var(--color-silver);
      }
      &.bleached-silk {
        color: var(--color-bleached-silk);
      }
      &.anthrazit {
        color: var(--color-livique-anthrazit);
      }
      &.cherryade {
        color: var(--color-livique-cherryade);
      }
      &.blue {
        color: var(--color-blue);
      }
      &.green-seduction {
        color: var(--color-livique-green-seduction);
      }
      &.success {
        color: var(--color-success);
      }
      &.warning {
        color: var(--color-warning);
      }
      &.danger {
        color: var(--color-danger);
      }
    }
  }
}
